import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

import { isStudio5Route } from './route-manifest';

type AppRouterProps = {
  studio5Content: ReactElement;
  studioClassicContent: ReactElement;
};

export const AppRouter = ({
  studio5Content,
  studioClassicContent,
}: AppRouterProps) => {
  const { pathname } = useLocation();

  if (isStudio5Route(pathname)) {
    return studio5Content;
  }

  return studioClassicContent;
};
